import {
  LOGIN_REQUEST,
  LOGIN_SUCCESS,
  LOGIN_FAILURE,
  LOGIN_RESET,
} from "../actions/auth";
import { LOGOUT_REQUEST, LOGOUT_SUCCESS } from "../actions/auth";

const initialState = {
  state: "idle",
};

export default function auth(state = initialState, action) {
  switch (action.type) {
    case LOGIN_REQUEST:
      return {
        ...state,
        state: "loading",
      };
    case LOGIN_SUCCESS:
      return {
        ...state,
        ...action.payload,
        state: "success",
      };
    case LOGIN_FAILURE:
      return {
        ...state,
        ...action.payload, //помилка авторизації
        state: "failure",
        // message: action.payload.result.message,
      };
    case LOGIN_RESET:
      return {
        ...initialState,
      };
    case LOGOUT_REQUEST:
      return {
        ...state,
        state: "loading",
      };
    case LOGOUT_SUCCESS:
      return {
        ...initialState,
        state: "success",
      };
    default:
      return state;
  }
}
